import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel'
import { EmblaCarouselType } from 'embla-carousel'
import { qsRequired } from '@/scripts/core/global'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'

export class BeforeAfter extends UcoastEl {
	static htmlSelector = 'before-after'
	allSlidesLoaded = false
	constructor() {
		super()
		const OPTIONS: EmblaOptionsType = {
			inViewThreshold: 1,
			containScroll: 'keepSnaps',
			align: 'start',
		}

		// a single slide has nothing to swipe to, so leave it static
		if (this.querySelectorAll('.embla__slide').length < 2) return

		const viewportNode = qsRequired('.embla__viewport', this)
		const prevBtn = qsRequired('.embla__button--prev', this)
		const nextBtn = qsRequired('.embla__button--next', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])

		emblaApi.on('select', (event) => {
			const index = event.selectedScrollSnap()
			event.slideNodes().forEach((slideNode, i) => {
				if (i == index) {
					window.Ucoast.mediaManager.loadAllInContainer(slideNode)
				}
			})

			if (this.allSlidesLoaded) return
			void window.Ucoast.mediaManager.preloadContainer(this)
			this.allSlidesLoaded = true
		})
		emblaApi.on('scroll', (event) => {
			if (this.allSlidesLoaded) return
			void window.Ucoast.mediaManager.loadAllInContainer(this)
			this.allSlidesLoaded = true
		})

		const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
			emblaApi,
			prevBtn,
			nextBtn
		)

		emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
	}
}

const addTogglePrevNextBtnsActive = (
	emblaApi: EmblaCarouselType,
	prevBtn: HTMLElement,
	nextBtn: HTMLElement
): (() => void) => {
	const togglePrevNextBtnsState = (): void => {
		if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
		else prevBtn.setAttribute('disabled', 'disabled')

		if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
		else nextBtn.setAttribute('disabled', 'disabled')
	}

	emblaApi
		.on('select', togglePrevNextBtnsState)
		.on('init', togglePrevNextBtnsState)
		.on('reInit', togglePrevNextBtnsState)

	return (): void => {
		prevBtn.removeAttribute('disabled')
		nextBtn.removeAttribute('disabled')
	}
}

export const addPrevNextBtnsClickHandlers = (
	emblaApi: EmblaCarouselType,
	prevBtn: HTMLElement,
	nextBtn: HTMLElement
): (() => void) => {
	const scrollPrev = () => emblaApi.scrollPrev()
	const scrollNext = () => emblaApi.scrollNext()
	prevBtn.addEventListener('click', scrollPrev, false)
	nextBtn.addEventListener('click', scrollNext, false)

	const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
		emblaApi,
		prevBtn,
		nextBtn
	)

	return (): void => {
		removeTogglePrevNextBtnsActive()
		prevBtn.removeEventListener('click', scrollPrev, false)
		nextBtn.removeEventListener('click', scrollNext, false)
	}
}
